// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","li":"ProCon_li__8qdPB","iconCol":"ProCon_iconCol__mWYXI","textCol":"ProCon_textCol__QaVwj"};